import { render } from "./Minit.vue?vue&type=template&id=6b92383a"
import script from "./Minit.vue?vue&type=script&lang=js"
export * from "./Minit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__